import { Empty } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';
import React from 'react';
import TranslationKey from 'src/i18n/translation';

interface EmptyBoxProps {
  title?: string;
  iconSize?: number;
  icon?: React.ReactNode;
}

const EmptyBox: React.FC<EmptyBoxProps> = ({
  title,
  iconSize = 75,
  icon = <FileImageOutlined />,
}) => {
  return (
    <div style={{ padding: '20px 0', textAlign: 'center' }}>
      <Empty
        image={icon}
        imageStyle={{ fontSize: iconSize, color: '#aaa' }}
        description={
          <p style={{ fontSize: '1.25rem', color: '#aaa', paddingTop: '10px' }}>
            {
              title ? title : TranslationKey('emptyBox.title')
            }
          </p>
        }
      />
    </div>
  );
};

export default EmptyBox;
